import * as Sentry from "@sentry/react";
import { useHistory, useLocation } from "react-router-dom";
import firebase from "../Firebase.js";
import { isStagingBranch } from "../IsStagingBranch.js";
import { useAppStore } from "../stores/appStore.js";
import { AppEventPublisher } from "../AppEventPublisher.js";

const useAppleSignIn = () => {
  const provider = new firebase.auth.OAuthProvider("apple.com");
  const location = useLocation();
  const history = useHistory();
  const mergeAccount = useAppStore((state) => state.mergeAccount);
  const setMergeAccount = useAppStore((state) => state.setMergeAccount);

  const appleSignIn = () => {
    AppEventPublisher.meta.loginWithApplePressed();

    if (history && !location.pathname.startsWith("/app/") && !location.pathname.startsWith("/pages")) {
      history.push("/?fromAuth");
    }

    const currentUser = firebase.auth().currentUser;

    if (process.env.NODE_ENV === "development" || process.env.REACT_APP_NODE_ENV === "development" || isStagingBranch()) {
      if (currentUser && currentUser.isAnonymous && mergeAccount) {
        currentUser
          .linkWithPopup(provider)
          .then(() => {
            setMergeAccount(false);
          })
          .catch((error) => {
            if (error.code === "auth/credential-already-in-use") {
              return firebase.auth().signInWithCredential(error.credential);
            }

            Sentry.captureException(error, {
              tags: {
                func: "appleSignIn",
                userId: currentUser.uid,
              },
            });
          });
      } else {
        firebase.auth().signInWithPopup(provider);
      }
    } else {
      if (currentUser && currentUser.isAnonymous && mergeAccount) {
        window.location.hash = "login";
        currentUser.linkWithRedirect(provider);
      } else {
        window.location.hash = "login";
        firebase.auth().signInWithRedirect(provider);
      }
    }
  };

  return appleSignIn;
};

export default useAppleSignIn;
